import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { withViewport } from '../../util/uiHelpers';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './LandFindingPage.module.css';
import HeroSection from './Sections/HeroSection';
import VisitSupplierSection from './Sections/VisitSupplierSection';
import FeatureSection from './Sections/FeatureSection';

export const LandFindingPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      title={intl.formatMessage({ id: 'LandFindingPage.title' })}
      description={intl.formatMessage({ id: 'LandFindingPage.description' })}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <HeroSection />
          <FeatureSection />
          <VisitSupplierSection />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

LandFindingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const LandFindingPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withViewport,
  injectIntl
)(LandFindingPageComponent);

export default LandFindingPage;
